export const SEGMENT_ANONYMOUS_ID_COOKIE = "segment_anonymous_id";
export const CHECKOUT_ABTEST_COOKIE = "checkout_vercel_test";
